import React from "react";
import { Box, ButtonGroup, Button, } from "@mui/material";
import '../styles/style.scss';
import { OneClickTrading } from "../../api/request/dashboard/dashboard";
import toast from "react-hot-toast";
import { useSelector, shallowEqual } from "react-redux";
import AmountInput from '../../MobileView/components/Quote/AmountInput'
import { useTranslation } from "react-i18next";

const OneClick = ({ open, onClose, symbolName }) => {
  const { accountId: accountID } = useSelector(state => state.accountSummary)
  const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams, shallowEqual);
  const { globalSymbol: oneClickSymbolDetail = {} } = useSelector((state) => state.globalSymbol)
  const symbolId = oneClickSymbolDetail?.id;
  const digits = oneClickSymbolDetail?.digits
  const { t } = useTranslation()
  // const symbolData = symbols[symbolId] || {};
  const symbolData = useSelector(state => state.updateSymbol.symbols?.[symbolId])
  const bidPrice = symbolData?.bid || 0;
  const askPrice = symbolData?.ask || 0;
  const symbolParameterData = symbolId ? allSymbolParams[symbolId] : {};
  const value = useSelector((state) => state?.amount?.[symbolId] ?? symbolParameterData?.minimumAmountPerDeal ?? 0.01);

  const handleTrade = async (side) => {
    console.log('calling with side ', side);

    if (!symbolId) {
      console.error("Symbol ID is missing.");
      return;
    }

    if (value < symbolParameterData?.minimumAmountPerDeal || value > symbolParameterData?.maximumAmountPerDeal) {
      toast.error("Trade volume is out of allowed limits.");
      return;
    }

    try {
      const payload = {
        accountId: Number(accountID),
        side,
        amount: value,
        symbolId,
        comment: "One-click trading",
      };

      const response = await OneClickTrading(payload);
      if (response?.data?.id) {
        const tradeId = response.data.id;
        const symbolName = symbolData?.name;
        const price = side === 1 ? symbolData?.ask : symbolData?.bid;
        const tradeSide = side === 1 ? "BUY" : "SELL";

        toast.success(`Trade Opened: ID #${tradeId}, ${symbolName} at ${price ? price.toFixed(symbolData?.digits) : "0.00"}, ${tradeSide}, Amount: ${value}`);
      }
    } catch (error) {
      console.error("Trade execution error:", error);
      toast.error(`Trade execution failed`);
    }
  };

  const formatPrice = (price) => {
    return price ? price?.toFixed(digits) : "-";
  };
  if (!open) return null;
  return (
    <Box sx={{ position: 'absolute', padding: 12 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
        <Box>
          <ButtonGroup variant="" aria-label="sell group" sx={{ height: '25px' }} onClick={() => handleTrade(-1)}>
            <Button sx={{ backgroundColor: symbolData?.bidColor === 'down' ? '#da5244' : symbolData?.bidColor === 'up' ? '#079a80' : 'var(--fallback-bg)', color: symbolData?.bidColor ? 'white' : 'var(--fallback-color)', paddingRight: 1, borderRadius: 0, paddingLeft: 1, }}>{formatPrice(bidPrice) || "0.00"}</Button>
            <Button sx={{ backgroundColor: symbolData?.bidColor === 'down' ? '#da5244' : symbolData?.bidColor === 'up' ? '#079a80' : 'var(--fallback-bg)', color: symbolData?.bidColor ? 'white' : 'var(--fallback-color)', padding: '3px', px: 1, borderRadius: 0, }}>{t("SELL")}</Button>
          </ButtonGroup>
        </Box>
        <AmountInput symbolId={symbolId} />
        <Box>
          <ButtonGroup variant="" aria-label="buy group" sx={{ height: '25px' }} onClick={() => handleTrade(1)}>
            <Button sx={{ backgroundColor: symbolData?.askColor === 'down' ? '#da5244' : symbolData?.askColor === 'up' ? '#079a80' : 'var(--fallback-bg)', color: symbolData?.askColor ? 'white' : 'var(--fallback-color)', padding: '3px', px: 1, borderRadius: 0, }}>{t("BUY")}</Button>
            <Button sx={{ backgroundColor: symbolData?.askColor === 'down' ? '#da5244' : symbolData?.askColor === 'up' ? '#079a80' : 'var(--fallback-bg)', color: symbolData?.askColor ? 'white' : 'var(--fallback-color)', paddingRight: 1, borderRadius: 0, paddingLeft: 1, }}>{formatPrice(askPrice) || "0.00"}</Button>
          </ButtonGroup>
        </Box>

      </Box>
    </Box>
  );


};

export default OneClick;
